import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-expired',
  templateUrl: './link-expired.component.html',
})
export class LinkExpiredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
